export default {
  includeDefaultLocalization: true,
  useTenantAndPolicyIdFromSettings: true,
  addRandomPolicyIdTail: true,
  rpNameTestRandomization: true,
  policyId: 'B2C_1A_PolicyBase',
  // Enables one set of tenant settings
  // target: 'dev',
  target: 'prod',
  // target: 'tenantAgnostic',
  tenantSettings: {
    dev: {
      tenantName: 'gpdevb2c',
      tenantId: 'gpdevb2c.onmicrosoft.com',
      tenantIdNum: '7bd23860-e13d-4cf0-bbc7-a4a56c3dc0e3',
      IEFAppId: 'a82e28dd-b16b-473a-a3a3-c3c486a5c59f',
      proxyIEFAppId: 'eccdc34e-ac00-4609-914f-48a0b0393d67',
      extensionAppClientId: '9cbd6f17-3de3-4b61-badc-73d8f38abe19',
      extensionAppObjectId: 'db7ec858-bf05-46fe-bbb2-8a6aa462044e',
      performAutoUpload: false,
      samlAppCertReference: 'B2C_1A_samlTestCert',
      samlIssuerUri: 'https://testapp1.gpdevb2c.onmicrosoft.com',
      oidcTestAppId: '980626d3-2efc-402c-9335-f05c32d94ff8',
      samlTestAppId: '02e8bc94-6e7b-4d75-a354-9cbd91cac7a5',
      tokenSigningKeyContainer: 'B2C_1A_TokenSigningKeyContainer',
      tokenEncryptionKeyContainer: 'B2C_1A_TokenEncryptionKeyContainer',
    },
    prod: {
      tenantName: 'gptestb2corg',
      tenantId: 'gptestb2corg.onmicrosoft.com',
      tenantIdNum: 'dcce0867-073b-4819-9862-133adeb6bd7f',
      IEFAppId: 'f9b3b389-0b7a-4690-aa21-128bfd2b30af',
      proxyIEFAppId: '4fd657d2-9232-45c7-9246-736ed750c162',
      extensionAppClientId: 'e98d96c4-633d-478f-9518-460918ad25c1',
      extensionAppObjectId: 'e8f4092d-f8d6-493b-bb59-bc76299408ad',
      performAutoUpload: true,
      samlAppCertReference: 'B2C_1A_gpTestSamlTestCert',
      samlIssuerUri: 'https://samltestapp.gptestb2corg.onmicrosoft.com',
      oidcTestAppId: 'de27c7d9-1880-447b-aa24-2ac363bd08d7',
      samlTestAppId: '839a96ec-7335-4b40-8011-f0473ed0a256',
      tokenSigningKeyContainer: 'B2C_1A_TokenSigningKeyContainer',
      tokenEncryptionKeyContainer: 'B2C_1A_TokenEncryptionKeyContainer',
    },
    tenantAgnostic: {
      tenantName: '{settings:tenantName}',
      tenantId: '{settings:tenantDomain}',
      tenantIdNum: '{settings:tenantID}',
      IEFAppId: '{settings:IEFApplicationID}',
      proxyIEFAppId: '{settings:proxyIEFApplicationID}',
      extensionAppClientId: '{settings:extensionApplicationClientID}',
      extensionAppObjectId: '{settings:extensionApplicationObjectID}',
      performAutoUpload: false,
      samlAppCertReference: '{settings:samlCertContainerID}',
      samlIssuerUri: '{settings:samlIssuerUri}',
      oidcTestAppId: '{settings:OIDCtestApplicationID}',
      samlTestAppId: '{settings:SAMLtestApplicationID}',
      tokenSigningKeyContainer: '{settings:tokenSigningKeyContainer}',
      tokenEncryptionKeyContainer: '{settings:tokenEncryptionKeyContainer}',
    },
  },
  enableAIJsonAndXmlLog: true,
  aiTraceChunkSize: 32767,
  policyUploadUri: 'https://gritiamapponboardingtest.azurewebsites.net/api/deployPolicies?code=kOIp0MJYcnN_G7CTUHxOPnFXDEQNiOHNl7gcllR0XgNqAzFufn_jvQ==',
  policyDeleteUri: 'https://iefeditorupload-functionapp20220930204814.azurewebsites.net/api/DeletePolicyById?policy=',
  useTestSocialIds: true,
  testSocialIDs: {
    google: {
      clientId: '489833069051-brcp1su11trjdnu615vf9n4brkn4eqcl.apps.googleusercontent.com',
      clientSecretRef: 'B2C_1A_GoogleSecretGT',
    },
  },
  enableGeneratedApplicationInsights: true, // Enables application insights in generated XML. For safety, keep this on false except when you want to generate an instrumented policy.
  policyAIInstrumentationKey: '3c6fb700-ea88-48fa-982f-596dce17316f', // Used with the above when generating instrumented policies.
  stringHandlerApiUri:
    'https://gritstringhandlerapi.azurewebsites.net/api/strcmp?code=aBB9P6lASSdTjiIhV9f3zmwBrtmHlECM8Y3hxxFpVFAUAzFuUv9bmg==',
  runNowDeploymentUriA: 'https://gptestb2corg.b2clogin.com/gptestb2corg.onmicrosoft.com/oauth2/v2.0/authorize?p=',
  runNowDeploymentUriB:
    '&client_id=de27c7d9-1880-447b-aa24-2ac363bd08d7&nonce=defaultNonce&redirect_uri=https%3A%2F%2Fjwt.ms&scope=openid&response_type=id_token&prompt=login',
  runNowSamlDeploymentUri: 'https://samltestapp2.azurewebsites.net/SP',
  showGeneratedXMLInConsole: true,
  performAutoDeletion: true,
  webAuthnRegistrationContentDefinitionUri:
    'https://gritwebauthncontent.blob.core.windows.net/contents/defaults/webAuthnRegistrationDefault.html',
  webAuthnAuthenticationContentDefinitionUri:
    'https://gritwebauthncontent.blob.core.windows.net/contents/defaults/webAuthnLoginDefault.html',
  webAuthnCredentialExistsContentDefinitionUri:
    'https://gritwebauthncontent.blob.core.windows.net/contents/defaults/webAuthnDetectCredentialDefault.html',
  webAuthnAvailabilityContentDefinitionUri:
    'https://gritwebauthncontent.blob.core.windows.net/contents/defaults/webAuthnAvailabilityDefault.html',
  defaultWebAuthnStorageAPIUrl: 'https://customerdemoapis20221017194203.azurewebsites.net/api',
  defaultWebAuthnMakeCredentialAPIUrl:
    'https://gritwebauthncredentialapis.azurewebsites.net/api/makeCredential?code=Ymjt7hXs6w2wpdnBk2UW-lqrc8yywJOz7f3Y8gD_B46JAzFuZJTOxA==',
  defaultWebAuthnAssertionAPIUrl:
    'https://gritwebauthncredentialapis.azurewebsites.net/api/assertion?code=WscHyTcuuPN_fxKETtiaWDFxDchKNCYZEbIPlyCipZQtAzFuyOrgoQ==',
  internallyLinkErrorPagesToTokenIssuer: false,
  enablePolicyWideInstrumentation: false,
  includeGeneratedClaimsInInstrumentation: false,
  allowTenantSettingsConfigFileFetch: true,
  instrumentPolicyHTMLWithLR: false,
  outputExtraBranchVarInfo: false,
};
